"use client"

import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from "react"

type StatusBarChromeContextValue = {
  /**
   * True while the main app shell shows the dark fixed dashboard header under the status bar.
   * In that case we always use light status-bar glyphs (Capacitor Style.Dark / "DARK").
   */
  statusBarOverDarkHeader: boolean
  setStatusBarOverDarkHeader: (value: boolean) => void
}

const StatusBarChromeContext = createContext<StatusBarChromeContextValue | null>(null)

export function StatusBarChromeProvider({ children }: { children: ReactNode }) {
  const [statusBarOverDarkHeader, setState] = useState(false)
  const setStatusBarOverDarkHeader = useCallback((value: boolean) => {
    setState(value)
  }, [])

  const value = useMemo(
    () => ({ statusBarOverDarkHeader, setStatusBarOverDarkHeader }),
    [statusBarOverDarkHeader, setStatusBarOverDarkHeader]
  )

  return (
    <StatusBarChromeContext.Provider value={value}>{children}</StatusBarChromeContext.Provider>
  )
}

export function useStatusBarChrome() {
  const ctx = useContext(StatusBarChromeContext)
  if (!ctx) {
    throw new Error("useStatusBarChrome must be used within StatusBarChromeProvider")
  }
  return ctx
}
